import axios from "axios";

export default axios.create({
  baseURL:
    "https://europe-west2-ifis-trend-analytics-platform.cloudfunctions.net/api/",
  headers: {
    "Content-type": "application/json"
  }
});
